module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    attrs: {
      "md-active": _vm.isDialogVisible
    },
    on: {
      "update:mdActive": function($event) {
        _vm.isDialogVisible = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-dialog-content', [_c('div', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(_vm.instructions))])]), _vm._v(" "), _c('md-dialog-content', _vm._l((_vm.dialogInputs), function(input) {
    return _c('EditField', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!input.hidden),
        expression: "!input.hidden"
      }],
      key: input.label,
      attrs: {
        "edit": !input.disabled,
        "input": input
      }
    })
  })), _vm._v(" "), _c('md-dialog-content', [_vm._t("default")], 2), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f2eb8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/modalDialog.vue
// module id = 438
// module chunks = 1